/** Inline style objects the WhatsApp screens share (the kit is written with inline layout). */
export const muted = { margin: 0, fontSize: 13, color: "var(--rd-text-tertiary)" } as const;
export const mono = {
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
  fontSize: 12,
} as const;
export const preStyle = {
  margin: 0,
  maxHeight: 256,
  overflow: "auto",
  padding: "12px 14px",
  borderRadius: "var(--rd-radius-lg)",
  background: "var(--rd-surface-soft)",
  boxShadow: "inset 0 0 0 1px var(--rd-line-header)",
  ...mono,
  lineHeight: 1.55,
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
  textAlign: "start",
} as const;

export const kvStyle = {
  margin: 0,
  gridTemplateColumns: "minmax(110px, 40%) minmax(0, 1fr)",
  fontSize: 13,
  alignItems: "start",
} as const;

export const summaryStyle = {
  cursor: "pointer",
  fontSize: 13,
  fontWeight: 500,
  color: "var(--rd-text-secondary)",
} as const;

export const sectionHeading = {
  margin: 0,
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: "var(--rd-text-meta)",
} as const;

export const listStyle = {
  margin: 0,
  padding: 0,
  listStyle: "none",
  display: "flex",
  flexDirection: "column",
  gap: 12,
} as const;

export const rowButton = {
  border: 0,
  padding: 0,
  background: "transparent",
  font: "inherit",
  color: "inherit",
  textAlign: "start",
  cursor: "pointer",
  minWidth: 0,
  maxWidth: "100%",
} as const;


/** A filter bar: a soft panel above the table. */
export const filterForm = {
  display: "flex",
  flexDirection: "column",
  gap: 12,
  minWidth: 0,
  padding: "14px 16px",
  borderRadius: "var(--rd-radius-card)",
  background: "var(--rd-surface)",
  boxShadow: "var(--rd-shadow-card)",
} as const;

export const errorText = { margin: 0, fontSize: 13, color: "var(--rd-red)" } as const;
